import { trigger, transition, style, animate } from '@angular/animations';

export const appSmoothHeight = trigger('grow', [
  transition(
    ':enter',
    [
      style({ height: '0', overflow: 'hidden' }),
      animate('{{inDelay}}s ease-out', style({ height: '*' })),
    ],
    { params: { inDelay: 1.5 } },
  ),
  transition(
    ':leave',
    [
      animate(
        '{{outDelay}}s ease-in',
        style({ height: 0, overflow: 'hidden' }),
      ),
    ],
    { params: { outDelay: 1.5 } },
  ),
]);

export const ngForFadeInOut = trigger('fadeInOut', [
  transition(
    ':enter',
    [
      style({ height: 0, opacity: '0', overflow: 'hidden' }),
      animate('{{inDelay}}s ease-out', style({ height: '*', opacity: '1' })),
    ],
    { params: { inDelay: 1.5 } },
  ),
  transition(
    ':leave',
    [
      style({ opacity: '1', overflow: 'hidden' }),
      animate('{{outDelay}}s ease-in', style({ height: 0, opacity: '0' })),
    ],
    { params: { outDelay: 0.3 } },
  ),
]);

export const ngForFadeInOpacity = trigger('fadeInOpacity', [
  transition(
    ':enter',
    [
      style({ opacity: '0' }),
      animate('{{inDelay}}s ease-out', style({ opacity: '1' })),
    ],
    { params: { inDelay: 1.5 } },
  ),
]);
